export default "__VITE_ASSET__CpUDV3$M__"